// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:errors` (see frontend/package.json).
// Source: agent.shared.types.repository.SyncConflictError

import { RpcError, registerRpcError } from "@/app_store/rpc_error";

// Wire shape of this error: `code` discriminates the type, `message` is the
// human-readable text, and the remaining keys are the exception's own fields.
export interface SyncConflictErrorData {
    code: "SyncConflictError";
    message: string;
}

export class SyncConflictError extends RpcError {
    readonly code = "SyncConflictError" as const;

    constructor(data: SyncConflictErrorData) {
        super(data.code, data.message, data);
    }
}

registerRpcError("SyncConflictError", SyncConflictError);
